module.exports = "<app-nav-bar></app-nav-bar>\n\n<router-outlet></router-outlet>\n\n<app-footer></app-footer>"